<div class="search-results-container" #graph>
</div>
